export default __webpack_public_path__ + "static/media/monstera_still.821615e3.png";